/* The ways to post. A plain Post shares something; every other type is a
   request — something the member wants to achieve — and goes on their Open
   Requests until they mark it done. Wording from the founders' design. */
export const POST_TYPES = [
  {
    key: 'post', label: 'Post', icon: 'compose', request: false,
    tagline: "What's on your mind today?",
    body: 'What are you working on, stuck on, or thinking about?',
  },
  {
    key: 'ask', label: 'Ask', icon: 'faq', request: true,
    tagline: 'Ask for feedback — or get unstuck',
    headline: 'e.g. Feedback on our pricing page',
    body: "What do you need a view on, and what have you tried? A link or screenshot helps.",
  },
  {
    key: 'test', label: 'Test', icon: 'flask', request: true,
    tagline: 'Test your product with users',
    headline: 'e.g. Need 5 beta testers for our DeFi app',
    body: 'Who should test it, how long it takes, and what they get in return. Add the link.',
  },
  {
    key: 'offer', label: 'Offer', icon: 'gift', request: true,
    tagline: 'Offer help, expertise or access',
    headline: 'e.g. GTM feedback for early-stage founders',
    body: "What you're offering, who it's for, and how to take you up on it.",
  },
  {
    key: 'intro', label: 'Intro', icon: 'intro', request: true,
    tagline: 'Make an intro or referral',
    headline: 'e.g. AI founders ↔ seed investors',
    body: 'Who you can connect, and who should reach out.',
  },
  {
    key: 'refer', label: 'Refer', icon: 'gift', request: true,
    tagline: 'Recommend someone for an opportunity — a referral reward is optional',
    headline: 'The role, e.g. Senior Blockchain Engineer',
    body: 'What the role is and who would be a great fit. Members tap “Refer someone”.',
  },
  {
    key: 'looking_for', label: 'Looking For…', icon: 'search', request: true,
    tagline: 'Find a co-founder, developer, expertise…',
    headline: 'e.g. AI engineer for our MVP',
    body: 'The role, the commitment (co-founder, part-time, paid…), and what makes it interesting.',
  },
];

export const TYPE_BY_KEY = Object.fromEntries(POST_TYPES.map((t) => [t.key, t]));
export const isRequest = (kind) => Boolean(TYPE_BY_KEY[kind]?.request);
